<template>
  <div class="data_table_container flex-col">
    <div class="table_header flex-row justify-start">
      <span
        v-for="header in props.headers"
        :key="header.key"
        class="header_cell"
        :style="header.style"
        >{{ header.label }}</span
      >
    </div>
    <div class="section_divider flex-col" />
    <div class="table_items_list flex-col justify-start">
      <div
        class="table_item_wrapper flex-row"
        :class="{ 'even-row': index % 2 === 0, selected: index === idx }"
        v-for="(item, index) in props.items"
        :key="index"
        @click="handleItemClick(item, index)"
      >
        <span
          v-for="header in props.headers"
          :key="header.key"
          class="cell"
          :style="header.cellStyle"
          v-html="item[header.key]"
        ></span>
      </div>
    </div>
  </div>
  <div
    class="pagination flex-row justify-end"
    v-if="showPagination"
  >
    <img
      class="label_left"
      referrerpolicy="no-referrer"
      src="../../assets/components/FigmaDDSSlicePNGd4c8b146c5e977ba18d058cd878be396.png"
      @click="handleClickPage(-1)"
    />
    <span class="text_pagination"
      >第{{ currentPage }}/{{ Math.ceil(props.total / props.pageSize) }}页</span
    >
    <img
      class="label_right"
      referrerpolicy="no-referrer"
      src="../../assets/components/FigmaDDSSlicePNG909fa7b2d82f34f9422697337d76c62a.png"
      @click="handleClickPage(1)"
    />
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, onBeforeMount } from "vue"

const props = defineProps({
  /** 表头配置数组 [{ key: '字段名', label: '标题', style: '表头样式', cellStyle: '单元格样式' }] */
  headers: {
    type: Array,
    required: true,
    validator: (value) => {
      return value.every((header) => header.key && header.label)
    },
  },
  /** 表格数据数组 */
  items: {
    type: Array,
    required: true,
    default: () => [],
  },
  /** 是否显示条纹行 */
  striped: {
    type: Boolean,
    default: true,
  },
  showPagination: {
    type: Boolean,
    default: false,
  },
  total: {
    type: Number,
    default: 1,
  },
  pageSize: {
    type: Number,
    default: 1,
  },
  idx: {
    type: Number,
    default: -1,
  },
})
const idx = ref(-1)
const currentPage = ref(1)

onBeforeMount(() => {
  idx.value = props.idx
})

const emit = defineEmits(["item-click"])

/** 处理列表项点击 */
const handleItemClick = (item, index) => {
  idx.value = index
  emit("item-click", item)
}

const handleClickPage = (page) => {
  currentPage.value += page
  if (currentPage.value < 1) {
    currentPage.value = 1
  } else if (currentPage.value > Math.ceil(props.total / props.pageSize)) {
    currentPage.value = Math.ceil(props.total / props.pageSize)
  } else {
    emit("page-change", currentPage.value)
  }
}
</script>

<style scoped>
.data_table_container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-bottom: 16px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
}

.table_header {
  width: 100%;
  height: 1.36vw;
  margin: 1.51vw 0 0 0;
}

.header_cell {
  min-width: 5vw;
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  color: rgba(112, 119, 126, 1);
  line-height: 1.05vw;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  height: 1.36vw;
  overflow-wrap: break-word;
}

.section_divider {
  background-color: rgba(217, 217, 217, 1);
  width: 100%;
  height: 0.11vw;
  margin-top: 0.84vw;
}

.table_items_list {
  width: 100%;
  height: calc(100% - 2.5vw);
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 16px;
}

.table_item_wrapper {
  width: 100%;
  height: 2.5vw;
  cursor: pointer;
}

.table_item_wrapper:hover {
  background-color: rgba(205, 230, 255, 1);
}

.even-row {
  background-color: rgba(247, 251, 255, 1);
}

.selected {
  background-color: rgba(104, 162, 250, 1);
}

.cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 2.5vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  line-height: 2.5vw;
  margin: 0;
}

.pagination {
  position: absolute;
  top: -2vw;
  right: 0;
}

.label_left {
  width: 1.31vw;
  height: 1.25vw;
  margin: 0 0 0 69.89vw;
  vertical-align: middle;
  cursor: pointer;
}

.text_pagination {
  width: auto;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.05vw 0.3vw 0 0.3vw;
}

.label_right {
  width: 1.31vw;
  height: 1.25vw;
  margin: 0;
  vertical-align: middle;
  cursor: pointer;
}
</style>
